class SessionManager {
  private static instance: SessionManager;
  private readonly sessionId: string | null = null;
  private readonly cookieName = 'session_id';

  private constructor() {
    this.sessionId = this.getOrCreateSessionId();
  }

  public static getInstance(): SessionManager {
    if (!SessionManager.instance) {
      SessionManager.instance = new SessionManager();
    }
    return SessionManager.instance;
  }

  private getCookie(name: string): string | undefined {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : undefined;
  }

  private setCookie(name: string, value: string) {
    const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    document.cookie = `${name}=${value}; path=/; max-age=86400; samesite=${isLocal ? 'Lax' : 'None'}${isLocal ? '' : '; Secure'}`;
  }

  private getOrCreateSessionId(): string {
    let sessionId = this.getCookie(this.cookieName);
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      this.setCookie(this.cookieName, sessionId);
    }
    return sessionId;
  }

  public getSessionId(): string {
    return this.sessionId!;
  }
}

export default SessionManager;
